import { render } from "./SelectOrderType.vue?vue&type=template&id=9f9b9d5a&scoped=true&ts=true"
import script from "./SelectOrderType.vue?vue&type=script&lang=ts"
export * from "./SelectOrderType.vue?vue&type=script&lang=ts"

import "./SelectOrderType.vue?vue&type=style&index=0&id=9f9b9d5a&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f9b9d5a"]])

export default __exports__